import { MDCSelect } from "@material/select";

function fundraiserSignupBlocked() {
  var value = $("form#sign_up_form").data("fundraiserSignupBlocked");
  return value === true || value === "true";
}

function showFundraiserBlockOnLoad() {
  var value = $("form#sign_up_form").data("showFundraiserBlock");
  return value === true || value === "true";
}

function openFundraiserBlockModal() {
  var modal = document.getElementById("season-wrap-up-modal");
  if (!modal) return;
  modal.hidden = false;
  modal.classList.add("is-open");
  var closeButton = document.getElementById("season-wrap-up-close");
  if (closeButton) closeButton.focus();
}

$(document).on("click", "#season-wrap-up-close", function () {
  closeFundraiserBlockModal();
});

function closeFundraiserBlockModal() {
  var closeButton = document.getElementById("season-wrap-up-close");
  if (closeButton && closeButton.dataset.closeUrl) {
    window.location = closeButton.dataset.closeUrl;
    return;
  }
  var modal = document.getElementById("season-wrap-up-modal");
  if (!modal) return;
  modal.hidden = true;
  modal.classList.remove("is-open");
}

$(document).on("turbolinks:load", function () {
  var $form = $("form#sign_up_form");
  if ($form.length > 0) {
    var $currentStep = $("input#sign_up_step");
    var $continueButton = $("button#sign_up_continue_btn");
    var $backButton = $("button#sign_up_back_btn");
    var $submitButton = $("input#sign_up_submit_btn");
    var containers = getContainers();

    //---------- check url parameters ----------
    var account = currentAccountType();
    var token = getQueryParameter("token") || getQueryParameter("claim_hash");
    var persistedStep = currentStep();
    if (account) setUpAccountTypeInput(account);

    var blockChairSignup = fundraiserSignupBlocked() && (account === "administrator" || showFundraiserBlockOnLoad());

    if (blockChairSignup) {
      $currentStep.val(0);
      resetStepContainers(0);
      openFundraiserBlockModal();
    } else if (persistedStep === 2) {
      resetStepContainers(2);
      setupChooseSchoolMenuList();
      restoreStudentSchoolSelects();
      getCustomCategories();
    } else if (persistedStep === 4) {
      resetStepContainers(4);
      setClubContainer(account === "administrator");
    } else {
      switch (account) {
        case "student":
          $backButton.hide();
          if (token) {
            $currentStep.val(1);
            resetStepContainers(1);
            setupChooseSchoolMenuList();
          } else {
            var skipTo = getQueryParameter("skip-to");
            var nextStep = 1;
            if (skipTo === "account-details") {
              nextStep = 1;
            }
            $currentStep.val(nextStep);
            resetStepContainers(nextStep);
            setupChooseSchoolMenuList();
          }
          getCustomCategories();
          break;
        case "administrator":
          $currentStep.val(3);
          resetStepContainers(3);
          setClubContainer(true);
          $backButton.hide();
          break;
        case "district":
          $currentStep.val(3);
          resetStepContainers(3);
          setClubContainer(false);
          $backButton.hide();
          break;
        default:
          $currentStep.val(0);
          resetStepContainers(0);
          break;
      }
    }

    //---------- disable field validations by account type ----------
    $submitButton.on("click", function (e) {
      if (fundraiserSignupBlocked() && currentAccountType() === "administrator") {
        e.preventDefault();
        e.stopPropagation();
        openFundraiserBlockModal();
        return;
      }
      var valid = checkRequiredInputsByAccountType(
        currentAccountType(),
        true
      );
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      // Hidden steps stay in the form. An empty required password there makes
      // the browser cancel submit with no message, so Continue looks frozen.
      releaseHiddenStepConstraints();
    });

    //---------- back button handler ----------
    $backButton.on("click", function () {
      scrollToTopPage();
      followStepContainer(
        currentAccountType(),
        currentStep(),
        -1
      );
    });

    //---------- continue button handler ----------
    $continueButton.on("click", function () {
      scrollToTopPage();
      var step = currentStep();
      var validStep = triggerInputsValidationByStep(containers[step]);

      if (step === 0) {
        var accountType = containers[0]
          .find('input[type="radio"]:checked')
          .val();
        if (fundraiserSignupBlocked() && accountType === "administrator") {
          openFundraiserBlockModal();
          return;
        }
        setQueryParameter("account", accountType);
        checkRequiredInputsByAccountType(accountType, false);
        if (accountType === "student") setupChooseSchoolMenuList();
      }

      if (validStep) {
        followStepContainer(
          currentAccountType(),
          step,
          1
        );
      }
    });

    setUpIsParentSelect();
    restoreParentRole();
    if (!getQueryParameter("REFERRALCODE")) {
      setUpOriginSelect();
      restoreOriginSelect();
    }
  }

  let forgotCodeModal = $("#forgot-code-modal");

  $("#forgot-code").on("click", function () {
    $(document.body).css("overflow", "hidden");
    forgotCodeModal.css("display", "block");
  });

  $("#forgot-code-modal-close").on("click", function () {
    $(document.body).css("overflow", "auto");
    forgotCodeModal.css("display", "none");
    $("#origin_referral_reference").val(null);
  });

  $("#forgot-code-modal-save").on("click", function () {
    $(document.body).css("overflow", "auto");
    forgotCodeModal.css("display", "none");
  });

  $(window).on("click", function (event) {
    if (event.target === forgotCodeModal.get(0)) {
      $(document.body).css("overflow", "auto");
      forgotCodeModal.css("display", "none");
      $("#origin_referral_reference").val(null);
    }
  });
});

//-----------------------methods--------------------------//
function scrollToTopPage() {
  window.scrollTo(0, 0);
}

function removeMenuListChildren($select) {
  var $oldChildren = $($select).find("li");
  $oldChildren.remove();
}

function fillMenuList($select, options, key, value) {
  removeMenuListChildren($select);
  options.forEach((option) => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" role="option" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML("beforeend", row);
  });
}

function fillMenuListWithDataAttr(
  $select,
  options,
  key,
  value,
  data,
  rewardCenterData
) {
  removeMenuListChildren($select);
  options.forEach((option) => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" data-${data}="${option[data]}" data-has_reward_center="${option["reward_center"]}" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML("beforeend", row);
  });
}

function fillCityMenuList(stateId, $select, collection) {
  var options = collection[stateId.toString()] || [];
  fillMenuList($select, options, "city", "city");
}

function fillOrganizationMenuList(cityName, $select, collection) {
  var options = collection[cityName.toString()] || [];
  fillMenuListWithDataAttr(
    $select,
    options,
    "id",
    "name",
    "is_club",
    "reward_center"
  );
}

function getContainers() {
  return [
    $("div#step_0_container"),
    $("div#step_1_container"),
    $("div#step_2_container"),
    $("div#step_3_container"),
    $("div#step_4_container"),
  ];
}

function currentStep() {
  return parseInt($("input#sign_up_step").val());
}

function setQueryParameter(key, value) {
  var url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState(null, null, url);
}

function getQueryParameter(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function currentAccountType() {
  return normalizeAccountType(
    getQueryParameter("account") ||
      $("form#sign_up_form").data("accountType") ||
      $("input[name='account_type']:checked").val()
  );
}

function normalizeAccountType(account) {
  return account === "chairperson" ? "administrator" : account;
}

// Student: 0 -> 1 -> 2 (submit)
// Chair/district: 0 -> 3 -> 4 (submit)
function followStepContainer(account, step, direction) {
  var followStep;
  var $backButton = $("button#sign_up_back_btn");
  $backButton.show();
  $("button#sign_up_continue_btn").show();
  setupSubmitOptions("none");

  if (account === "student") {
    followStep = step + direction;
    if (direction === -1 && followStep === 1) {
      $backButton.hide();
    }
    if (direction === 1 && step === 1) {
      getCustomCategories();
    }
    if (followStep === 2) {
      setupSubmitOptions("block");
    }
  } else if (account === "administrator" || account === "district") {
    if (direction === 1 && step === 0) {
      followStep = 3;
      $backButton.hide();
      setClubContainer(account === "administrator");
    } else if (direction === 1 && step === 3) {
      followStep = 4;
      setupSubmitOptions("block");
    } else if (direction === -1 && step === 4) {
      followStep = 3;
      $backButton.hide();
    } else if (direction === -1 && step === 3) {
      followStep = 0;
      $backButton.hide();
    } else {
      followStep = step + direction;
    }
  } else {
    followStep = step + direction;
  }

  var containers = getContainers();
  containers[step].hide();
  containers[followStep].show();
  $("input#sign_up_step").val(followStep);
}

function setCustomCategoryFieldActive(field, active) {
  field.hidden = !active;
  const selectEl = field.querySelector(".mdc-select");
  if (selectEl) {
    selectEl.classList.toggle("mdc-select--required", active);
    selectEl.classList.toggle("mdc-select--disabled", !active);
    const anchor = selectEl.querySelector(".mdc-select__anchor");
    if (anchor) {
      anchor.setAttribute("aria-disabled", active ? "false" : "true");
    }
  }
  field.querySelectorAll("input").forEach(function (input) {
    input.disabled = !active;
  });
}

function deactivateCustomCategoryFields(customCategoriesDiv) {
  customCategoriesDiv.hidden = true;
  customCategoriesDiv.querySelectorAll(".v2-field").forEach(function (field) {
    setCustomCategoryFieldActive(field, false);
  });
}

function getCustomCategories() {
  const schoolId = $("input[name='user\\[student\\]\\[school_id\\]']").val();
  const customCategoriesDiv = document.querySelector("#custom-categories");
  if (!customCategoriesDiv) return;
  deactivateCustomCategoryFields(customCategoriesDiv);
  if (!schoolId) return;

  const host = window.location.host;
  const basePath = window.location.pathname.split("/")[1];
  $.ajax({
    url: `//${host}/${basePath}/schools/${schoolId}/campaign_custom_categories`,
    type: "GET",
    success: function (data) {
      const v2Fields = customCategoriesDiv.querySelectorAll(".v2-field");
      if (!data.length) {
        deactivateCustomCategoryFields(customCategoriesDiv);
        return;
      }

      data.forEach(function (category, i) {
        if (i >= v2Fields.length) return;
        const field = v2Fields[i];
        setCustomCategoryFieldActive(field, true);
        const selectEl = field.querySelector(".mdc-select");
        const label = field.querySelector(".mdc-floating-label");
        label.textContent =
          category.name.charAt(0).toUpperCase() +
          category.name.slice(1).toLowerCase();

        let input = field.querySelector(
          "input[name='user[student][categories][][id]']"
        );
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "user[student][categories][][id]";
          field.appendChild(input);
        }
        input.value = category.id;
        input.disabled = false;

        const options = field.querySelector(".mdc-select__menu");
        options.innerHTML = "";
        const ul = document.createElement("ul");
        ul.classList.add("mdc-list");
        category.campaign_custom_category_options.forEach(function (option) {
          const li = document.createElement("li");
          li.classList.add("mdc-list-item");
          li.dataset.value = option.id;
          li.textContent = option.name;
          li.setAttribute("role", "option");
          ul.appendChild(li);
        });
        options.appendChild(ul);
        const mdcSelect = new MDCSelect(selectEl);
        mdcSelect.disabled = false;
      });

      for (let i = data.length; i < v2Fields.length; i++) {
        setCustomCategoryFieldActive(v2Fields[i], false);
      }
      customCategoriesDiv.hidden = false;
      restoreCustomCategorySelects();
    },
    error: function (error) {
      deactivateCustomCategoryFields(customCategoriesDiv);
      console.log(error);
    },
  });
}

function resetStepContainers(step) {
  setupSubmitOptions("none");
  var containers = getContainers();
  containers.forEach((container) => {
    container.hide();
  });

  if (step === 0 || step === 1 || step === 3) {
    $("button#sign_up_back_btn").hide();
  }
  if ([2, 4].includes(step)) {
    setupSubmitOptions("block");
  }
  containers[step].show();
}

function setUpAccountTypeInput(account) {
  getContainers()[0]
    .find(`input#account_type_${account}`)
    .prop("checked", true);
}

function setupSubmitOptions(display) {
  let switchDisplay;
  if (display === "none") {
    switchDisplay = "block";
    $(".actions").addClass("end");
  } else {
    switchDisplay = "none";
    $(".actions").removeClass("end");
  }

  $("a#video_guidelines_link").css("display", display);
  $("div#privacy_terms_field").css("display", display);
  $("input#sign_up_submit_btn").css("display", display);
  $("button#sign_up_continue_btn").css("display", switchDisplay);
}

function setupChooseSchoolMenuList() {
  if (typeof itemCollections !== undefined) {
    var stateEl = document.querySelector(
      "div.mdc-select[data-element-type='address[state_id]']"
    );
    var cityEl = document.querySelector(
      "div.mdc-select[data-element-type='address[id]']"
    );
    var schoolEl = document.querySelector(
      "div.mdc-select[data-element-type='user[student][school_id]']"
    );
    var gradeEl = document.querySelector(
      "div.mdc-select[data-element-type='user[student][grade]']"
    );
    if (!stateEl || !cityEl || !schoolEl || !gradeEl) return;

    var stateSelect = new MDCSelect(stateEl);
    var citySelect = new MDCSelect(cityEl);
    var schoolSelect = new MDCSelect(schoolEl);
    var gradeSelect = new MDCSelect(gradeEl);

    stateSelect.listen("MDCSelect:change", function (data) {
      fillCityMenuList(
        data.detail.value,
        citySelect.menu.list_.root,
        itemCollections.cities
      );
    });

    citySelect.listen("MDCSelect:change", function (data) {
      fillOrganizationMenuList(
        data.detail.value,
        schoolSelect.menu.list_.root,
        itemCollections.organizations
      );
    });

    schoolSelect.listen("MDCSelect:change", function (data) {
      var $optionSelected = schoolSelect.menu.items[data.detail.index];
      $("input#student_school_name").val($optionSelected.textContent);
      var isSchool = $optionSelected.dataset.is_club === "false";
      if (isSchool) {
        gradeSelect.required = true;
      } else {
        gradeSelect.required = false;
      }
      getCustomCategories();
      if (!($optionSelected.dataset.has_reward_center === "true") || true) {
        $(".rewards_center_modal").hide();
      }
    });
  }
}

function checkRequiredInputsByAccountType(accountType, onSubmit) {
  let $noRequiredFields, $requiredFields, valid;
  var $studentContainers = $("div#step_1_container, #step_2_container");
  var $adminContainers = $("div#step_3_container, #step_4_container");

  if (onSubmit) {
    if (accountType === "student") {
      valid = triggerInputsValidationByStep($("div#step_2_container"));
      $noRequiredFields = $adminContainers.find("[required='required']");
    } else {
      valid = triggerInputsValidationByStep($("div#step_4_container"));
      $noRequiredFields = $studentContainers.find("[required='required']");
    }
    $noRequiredFields.each((_index, field) => {
      field.setAttribute("disabled", "");
    });
    return valid;
  } else {
    if (accountType === "student") {
      $requiredFields = $studentContainers.find("[required='required']");
    } else {
      $requiredFields = $adminContainers.find("[required='required']");
    }
    $requiredFields.each((_index, field) => {
      field.removeAttribute("disabled");
    });
  }
}

function setUpOriginSelect() {
  var originEl = document.querySelector(
    "div.mdc-select[data-element-type='origin[origin]']"
  );
  var repEl = document.querySelector(
    "div.mdc-select[data-element-type='origin[rep_email]']"
  );
  if (!originEl || !repEl) return;

  var originSelect = new MDCSelect(originEl);
  var representativeSelect = new MDCSelect(repEl);
  var $representativeName = $("input#origin_rep_name");
  var $referralCode = $("input#origin_referral_code");
  var $forgotCode = $("small#forgot-code");

  originSelect.listen("MDCSelect:change", function (data) {
    $representativeName.val(null);
    representativeSelect.root.style.display = "none";
    representativeSelect.layout();
    representativeSelect.required = false;
    $referralCode.val(null);
    $referralCode.hide();
    $forgotCode.css("display", "none");

    if (data.detail.value == "TMF Sales Rep") {
      representativeSelect.required = true;
      representativeSelect.root.style.display = "block";
    } else if (data.detail.value === "Referral") {
      $referralCode.show();
      $forgotCode.css("display", "flex");
    }
  });

  representativeSelect.listen("MDCSelect:change", function (data) {
    var $optionSelected = representativeSelect.menu.items[data.detail.index];
    $representativeName.val($optionSelected.textContent);
  });
}

function setUpIsParentSelect() {
  var roleEl = document.querySelector(
    "div.mdc-select[data-element-type='user[is_parent]']"
  );
  if (!roleEl) return;

  var roleSelect = new MDCSelect(roleEl);
  roleSelect.listen("MDCSelect:change", function (data) {
    var isParent = data.detail.value;
    var $birthdayInput = $("input#student_birthday");
    var $birthdayFieldGroup = $(".student-birthday-field-group");
    var $gradeSelect = $(
      "div.mdc-select[data-element-type='user[student][grade]']"
    );
    let $customCategories = $("#custom-categories");
    var $guardianBlock = $("#guardian_info_block");

    if (isParent === "true") {
      $birthdayInput.attr("disabled", "");
      $birthdayFieldGroup.hide();
      $gradeSelect.removeClass("mdc-select--required");
      $gradeSelect.parent().hide();
      $customCategories.find("div.mdc-select").removeClass("mdc-select--required");
      $customCategories.hide();
      $guardianBlock.hide();
      $guardianBlock.find("input").attr("disabled", "");
    } else {
      $birthdayFieldGroup.show();
      $birthdayInput.removeAttr("disabled");
      $gradeSelect.parent().show();
      $gradeSelect.addClass("mdc-select--required");
      if (!$customCategories.prop("hidden")) {
        $customCategories.show();
      }
      $customCategories.find(".v2-field:not([hidden]) div.mdc-select").each(function () {
        if ($(this).find(".mdc-list-item").length) {
          $(this).addClass("mdc-select--required");
        }
      });
      $guardianBlock.show();
      $guardianBlock.find("input").removeAttr("disabled");
    }
  });
}

function releaseHiddenStepConstraints() {
  $("form#sign_up_form [required]").each(function () {
    var step = $(this).closest("[id$='_container']");
    if (step.length && !step.is(":visible")) {
      this.removeAttribute("required");
    }
  });
}

function triggerInputsValidationByStep(container) {
  let valid, current;
  var $requiredFields = container.find("[required='required']");
  $requiredFields.each((_index, field) => {
    current = field.value.trim();
    field.value = current;
    field.reportValidity();
    valid = field.checkValidity();
    return valid;
  });

  if (valid === false) return valid;

  valid = triggerPhoneInputsValidationByStep(container);
  if (valid === false) return valid;

  var $requiredFieldsMDC = container.find(".mdc-select--required");
  if ($requiredFieldsMDC.length > 0) {
    $requiredFieldsMDC.each((_index, field) => {
      if (field.hidden || field.closest("[hidden]") || field.offsetParent === null) return true;
      valid = field.querySelector("input").value.trim() !== "";
      if (!valid && !field.classList.contains("mdc-select--invalid")) {
        field.classList.add("mdc-select--invalid");
      }
      return valid;
    });
  }
  return valid;
}

function triggerPhoneInputsValidationByStep(container) {
  var valid = true;
  var phoneInstances = window.itis || {};

  container.find("input[type='tel']").each((_index, field) => {
    var value = field.value.trim();
    var instance = phoneInstances[field.id];
    if (!value || !instance) return true;

    var $errorMsg = $(`#error-msg-${field.id}`);
    var $validMsg = $(`#valid-msg-${field.id}`);
    field.classList.remove("error");
    field.setCustomValidity("");
    $errorMsg.html("");
    $errorMsg.prop("hidden", true);
    $validMsg.prop("hidden", true);

    if (instance.isValidNumber()) {
      field.value = instance.getNumber();
      $validMsg.prop("hidden", false);
      return true;
    }

    field.classList.add("error");
    var errorCode = instance.getValidationError();
    var phoneErrorMap = window.errorMap || [
      "Invalid number",
      "Invalid country code",
      "Too short",
      "Too long",
      "Invalid number",
    ];
    var errorMessage = phoneErrorMap[errorCode] || phoneErrorMap[0];
    field.setCustomValidity(errorMessage);
    $errorMsg.html(errorMessage);
    $errorMsg.prop("hidden", false);
    field.reportValidity();
    valid = false;
    return false;
  });

  return valid;
}

function restoreStudentSchoolSelects() {
  var $form = $("form#sign_up_form");
  var stateId = $form.data("stateId");
  var city = $form.data("city");
  var schoolId = $form.data("schoolId");
  var grade = $form.data("grade");
  if (!stateId && !city && !schoolId && !grade) return;
  if (typeof itemCollections === "undefined") return;

  var stateEl = document.querySelector(
    "div.mdc-select[data-element-type='address[state_id]']"
  );
  var cityEl = document.querySelector(
    "div.mdc-select[data-element-type='address[id]']"
  );
  var schoolEl = document.querySelector(
    "div.mdc-select[data-element-type='user[student][school_id]']"
  );
  var gradeEl = document.querySelector(
    "div.mdc-select[data-element-type='user[student][grade]']"
  );
  if (!stateEl || !cityEl || !schoolEl || !gradeEl) return;

  var stateSelect = new MDCSelect(stateEl);
  var citySelect = new MDCSelect(cityEl);
  var schoolSelect = new MDCSelect(schoolEl);
  var gradeSelect = new MDCSelect(gradeEl);

  if (stateId) {
    fillCityMenuList(
      stateId,
      citySelect.menu.list_.root,
      itemCollections.cities
    );
    stateSelect.value = String(stateId);
  }
  if (city) {
    fillOrganizationMenuList(
      city,
      schoolSelect.menu.list_.root,
      itemCollections.organizations
    );
    citySelect.value = String(city);
  }
  if (schoolId) {
    schoolSelect.value = String(schoolId);
    var selected = schoolSelect.menu.items[schoolSelect.selectedIndex];
    if (selected) $("input#student_school_name").val(selected.textContent);
  }
  if (grade) gradeSelect.value = String(grade);
}

function restoreParentRole() {
  var isParent = $("form#sign_up_form").data("isParent");
  if (isParent === undefined || isParent === null || isParent === "") return;
  var roleEl = document.querySelector(
    "div.mdc-select[data-element-type='user[is_parent]']"
  );
  if (!roleEl) return;
  new MDCSelect(roleEl).value = String(isParent);
}

function restoreOriginSelect() {
  var $form = $("form#sign_up_form");
  var origin = $form.data("origin");
  var repEmail = $form.data("repEmail");
  if (!origin) return;
  var originEl = document.querySelector(
    "div.mdc-select[data-element-type='origin[origin]']"
  );
  if (!originEl) return;
  new MDCSelect(originEl).value = String(origin);
  if (!repEmail) return;
  var repEl = document.querySelector(
    "div.mdc-select[data-element-type='origin[rep_email]']"
  );
  if (!repEl) return;
  new MDCSelect(repEl).value = String(repEmail);
}

function restoreCustomCategorySelects() {
  var categories = $("form#sign_up_form").data("categories");
  if (!categories || !categories.length) return;
  var v2Fields = document.querySelectorAll("#custom-categories .v2-field");
  categories.forEach(function (category, i) {
    var field = v2Fields[i];
    if (!field) return;
    var response = category.response || category["response"];
    if (!response) return;
    var selectEl = field.querySelector(".mdc-select");
    if (!selectEl) return;
    new MDCSelect(selectEl).value = String(response);
  });
}

function setClubContainer(show) {
  var $adminContainers = $("div#step_3_container, #step_4_container");
  var $clubContainer = $adminContainers.find("div.field.club-container");
  if (!$clubContainer.length) return;
  if (show) {
    $clubContainer.find("input").removeAttr("disabled");
    $clubContainer.show();
  } else {
    $clubContainer.find("input").attr("disabled", "");
    $clubContainer.hide();
  }
}
